import React from "react";

export const ClientList = ({
  clientList,
  clientSelect,
  selectedClientId,
  affiliateList,
}) => {
  const clientListHTML = [];
  const clientRegistration = localStorage.getItem("clientRegistration");

  if (clientRegistration != null) {
    const ind = clientList.findIndex(
      (c) => c.clientUrlName === clientRegistration
    );
    clientList.push(...clientList.splice(0, ind));
  }

  clientList.forEach((client, index) => {
    let affiliateClientStatus = (
      <h3>
        <button className="btn linkButtons membership">
          <span>Request Membership</span>
        </button>
      </h3>
    );
    let canClick = true;
    let skipClient = false;

    affiliateList.forEach((affiliate) => {
      if (
        affiliate.affiliate.clientId === client.clientId &&
        affiliate.affiliate.status === "pending"
      ) {
        affiliateClientStatus = (
          <h3>
            <span className="label label-warning membership">
              Pending verification
            </span>
          </h3>
        );
        canClick = false;
      }

      //remove client if it is already an affiliate
      if (
        affiliate.affiliate.clientId === client.clientId &&
        affiliate.affiliate.status === "enabled"
      ) {
        skipClient = true;
      }
    });

    if (
      localStorage.getItem("requested_client") &&
      localStorage.getItem("requested_client") === client.clientId
    ) {
      affiliateClientStatus = (
        <h3>
          <span className="label label-warning membership">
            Pending verification
          </span>
        </h3>
      );
      canClick = false;
    }

    if (skipClient) {
      return;
    }

    let activeClient =
      client.clientId === selectedClientId ? "activeClient" : "";

    clientListHTML.push(
      <li
        key={`prodId${client.clientId}-${index}`}
        onClick={canClick ? (e) => clientSelect(e, client) : null}
        className={[activeClient, "clientListItem"].join(" ")}
      >
        <div className="clientLogoDiv">
          <img className="logoImg" src={client.logo} alt="" />
        </div>
        <p>Agreement type : {client.agreementType}</p>
        <p>Value type : {client.valueType}</p>
        <p>
          Return Value :{" "}
          {client.showValue ? client.baseReturnValue : "On request"}
        </p>
        {affiliateClientStatus}
      </li>
    );
  });

  return <ul className="clientList">{clientListHTML}</ul>;
};
